var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "basic-school" }, [
    _c("div", { staticClass: "basic-table-left" }, [
      _c("p", { staticClass: "table-th", class: _vm.hiddenClass }, [
        _vm._v(" 统计单位 "),
      ]),
      _c("p", { class: _vm.hiddenClass }, [
        _vm._v(
          " 有效分（总分有效分" +
            _vm._s(_vm.toPointFixed(_vm.school[_vm.lowerKey + "Score"])) +
            "） "
        ),
      ]),
      _c("div", { staticClass: "table-left-aside" }, [
        _c("div", { staticClass: "left-left" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.isFirst ? "本校" : _vm.school.schoolName)),
          ]),
          _c("span", [_vm._v("统计人数 " + _vm._s(_vm.school.studentNum))]),
          _c("span", [
            _vm._v(
              "上线人数 " + _vm._s(_vm.school["over" + _vm.lineKind + "Num"])
            ),
          ]),
          _c("span", [
            _vm._v(
              "上线比例 " + _vm._s(_vm.school[_vm.lowerKey + "ScoreRate"])
            ),
          ]),
        ]),
        _c("div", { staticClass: "left-right" }, [
          _c("p", [_vm._v("单上线人数")]),
          _c("p", [_vm._v("双上线人数")]),
          _c("p", [_vm._v("贡献率")]),
          _c("p", [_vm._v("命中率")]),
          _c(
            "p",
            [
              _vm._v(" 总分上线人数 "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: "选了该科目，且总分上线的学生数目",
                    placement: "top",
                  },
                },
                [_c("i", { staticClass: "el-icon-question" })]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "basic-table-right" },
      _vm._l(_vm.school.subjects, function (item) {
        return _c(
          "p",
          {
            key: item.subject + item.schoolId,
            staticClass: "table-right-subject",
          },
          [
            _c("span", { staticClass: "table-th", class: _vm.hiddenClass }, [
              _vm._v(_vm._s(item.subjectName)),
            ]),
            _c("span", { class: _vm.hiddenClass }, [
              _vm._v(
                " " +
                  _vm._s(_vm.toPointFixed(item[_vm.lowerKey + "Score"])) +
                  " "
              ),
            ]),
            _c("span", [
              _vm._v(" " + _vm._s(item["over" + _vm.lineKind + "Num"]) + " "),
            ]),
            _c("span", [
              _vm._v(
                " " + _vm._s(item["twiceOver" + _vm.lineKind + "Num"]) + " "
              ),
            ]),
            _c("span", [
              _vm._v(
                " " + _vm._s(item[_vm.lowerKey + "ContributionRate"]) + " "
              ),
            ]),
            _c("span", [
              _vm._v(" " + _vm._s(item[_vm.lowerKey + "HitRate"]) + " "),
            ]),
            _c("span", [
              _vm._v(
                " " + _vm._s(item["overTotal" + _vm.lineKind + "Num"]) + " "
              ),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }